import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  host: { class: 'hidden' },
  selector: 'file-archive-download-component',
  templateUrl: './file-archive-download.component.html',
})
export class FileArchiveDownloadComponent {
  ids: number[];

  url: string;

  @ViewChild('form', { static: false }) form: ElementRef<HTMLFormElement>;

  submit() {
    this.form.nativeElement.submit();
  }
}
